import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import _ from 'lodash';

import { downloadPdf, downloadXls } from '../../extensions/FileExtensions';
import { LocalModelMsg } from "../ModalMsg";

import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { NavLink } from 'reactstrap';
import Button from '@material-ui/core/Button';

import { CredBranchSelection, CredEmployeeSelection } from "../Selections";

import PrintIcon from '@material-ui/icons/Print';
import DescriptionIcon from '@material-ui/icons/Description';

const useStyles = makeStyles({
  title: {
    "& a.nav-link": {
      padding: "0px",
    },

    "& a.nav-link:hover h1": {
      color: "#006ed0",
    },

    "& h1": {
      paddingBottom: "15px",
      fontSize: "26px",
      lineHeight: "26px",
      fontWeight: "bold",
    },
  },
  frmFilter: {
    backgroundColor: "white",
    borderCollapse: "collapse",
    width: "100%",

    "& th": {
      fontWeight: 'bold',
      border: "1px solid #B0B0B0",
      backgroundColor: "#FAF3DE",
      padding: "2px 4px",
    },

    "& td": {
      border: "1px solid #B0B0B0",
      padding: "2px 4px",
    },

    "& label": {
      marginBottom: "0px",
    }
  },
});

export default function CredReportCommDue() {
  const classes = useStyles();

  const { jWTClaimModel: { Creds, User: { Role, BranchIds } } } = useSelector(state => {
    return state.auth;
  });

  const isSupervisor = (Role == "主管");
  const clericalBranchIds = ((Role == "分行文員") && JSON.parse(BranchIds ?? "")); // false or array
  //console.log('clericalBranchIds', clericalBranchIds);

  const [state, setState] = useState({
    idBranch: "",
    idEmployee: "",
  });

  const [msgState, msgSetState] = useState({ isShow: false, type: "", msg: "", fnConfirmed: null });

  const print = () => {
    const filter = _.keys(state).map(key => ({
      property: key,
      value: !_.isArray(state[key]) ? state[key] : JSON.stringify(state[key])
    }));
    //console.log(filter);

    downloadPdf("/api/CredReportCommDue/GetPDF", {
      filter: JSON.stringify(filter)
    }, '應收未收佣金報告.pdf', msgState, msgSetState);
  }

  const excel = () => {
    const filter = _.keys(state).map(key => ({
      property: key,
      value: !_.isArray(state[key]) ? state[key] : JSON.stringify(state[key])
    }));
    //console.log(filter);

    downloadXls("/api/CredReportCommDue/GetXlsx", {
      filter: JSON.stringify(filter)
    }, "應收未收佣金報告.xlsx", msgState, msgSetState);
  }

  return (
    <>
      <Breadcrumbs className={classes.title}>
        <Typography variant="h1" className={classes.title}>3.1. 應收未收佣金報告</Typography>
      </Breadcrumbs>

      {(isSupervisor || clericalBranchIds) && <div className="form-group row">
        <label htmlFor="calMonth" className="col-sm-2 col-form-label">分行:</label>
        <div className="col-sm-10">
          <CredBranchSelection className="form-control" isShowChoseEmployee={!clericalBranchIds} value={state.idBranch} onChange={(e) => { setState({ ...state, idBranch: e.target.value }); }} tabIndex="1" />
        </div>
      </div>
      }

      {!state.idBranch && isSupervisor && <div className="form-group row">
        <label htmlFor="calMonth" className="col-sm-2 col-form-label">同事:</label>
        <div className="col-sm-10">
          <CredEmployeeSelection showAny={false} className="form-control" value={state.idEmployee} onChange={(e) => { setState({ ...state, idEmployee: e.target.value }); }} tabIndex="3" />
        </div>
      </div>
      }

      <div className="mt-2 mb-3" style={{ textAlign: "center" }}>
        <Button startIcon={<PrintIcon />} className="mr-3" size="small" variant="contained" disableElevation onClick={print}>列　印</Button>
        <Button startIcon={<DescriptionIcon />} size="small" variant="contained" disableElevation onClick={excel}>Excel</Button>
      </div>

      <LocalModelMsg msgState={msgState} msgSetState={msgSetState} />
    </>
  );
}
